import React, { useState } from 'react';
import { Box, IconButton, Stack } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyTextToClipboard } from "../../../../action/copyTextToClipboard";
import OfferUrlFactory from "../../../../infrastructure/url-factory/OfferUrlFactory";
import Link from "../../../components/Link";

const OfferLinks: React.FC<OfferLinksProps> = props => {
    const [dropdownAnchor, setDropdownAnchor] = useState<Element>();

    return (
        <Box>
            <Box mb={ 1 }><b>Linki do oferty</b></Box>
            <Stack
                onClick={ e => setDropdownAnchor(dropdownAnchor ? undefined : e.currentTarget) }
            >
                <OfferLinkItem
                    text='Oferta PL'
                    link={ props.offerUrlFactory.pl(props.offerId) }
                    copyTextToClipboard={ props.copyTextToClipboard }
                />
                <OfferLinkItem
                    text='Oferta EN'
                    link={ props.offerUrlFactory.en(props.offerId) }
                    copyTextToClipboard={ props.copyTextToClipboard }
                />
            </Stack>
        </Box>
    );
}
export default OfferLinks;

export interface OfferLinksProps {
    readonly copyTextToClipboard: CopyTextToClipboard;
    readonly offerUrlFactory: OfferUrlFactory;
    readonly offerId: string;
}

const OfferLinkItem: React.FC<{ text: string, copyTextToClipboard: CopyTextToClipboard, link: string }> = props => {
    return (
        <Stack direction='row' alignItems='center' spacing={ 1 }>
            <IconButton
                size='small'
                onClick={ () => {
                    props.copyTextToClipboard(props.link);
                } }
            >
                <ContentCopyIcon fontSize='small'/>
            </IconButton>
            <Link to={ props.link } target='_blank'>
                <span style={ { textTransform: 'uppercase', fontWeight: 600 } }>{ props.text }</span>
            </Link>
        </Stack>
    );
}